import { ProductWrapper, useField } from '@kizi/comparator-core';
import { Div, DivProps, Label, List, ListItem, P } from '@kizi/core-components';
import { IconV2 as Icon } from '@kizi/shared-components';
import * as React from 'react';
import { withFormProps } from '../../HOCs';
import { Field } from '../index';
import { getCallGroup } from '../../ProductOverviewModalTriplePlay/getCallGroup';
import { getNetworkInformationGroup } from '../../ProductOverviewModalTriplePlay/getNetworkInformationGroup';
import { getTelevisionGroup } from '../../ProductOverviewModalTriplePlay/getTelevisionGroup';
import { DisplayGroup } from '../../ProductOverviewModalTriplePlay/groupInterfaces';
import { MoreInfoButton } from './MoreInfoButton';

export type PackageCompProps = {
  product: ProductWrapper;
  length?: number;
  onButtonInfoClick?: React.MouseEventHandler;
};

export type GroupToShow = {
  label: JSX.Element;
  value: string | number | JSX.Element | undefined;
  icon: string | undefined;
};

export const PackageComp: React.FC<PackageCompProps> = ({
  product,
  length,
  onButtonInfoClick,
}) => {
  const LabelWithTooltip = withFormProps(Label);
  const filters = useField('filters');
  const filtersData = JSON.parse(filters?.value as string).productTypes;

  const getGroup = (g: DisplayGroup): GroupToShow => {
    return {
      label: (
        <LabelWithTooltip
          _containerProps={{
            variant: 'packageLabel',
          }}
          _label={g.label}
          _tooltip={g.tooltip}
        />
      ),
      value: g.value,
      icon: g.icon,
    };
  };

  const sliceGroup = (group: GroupToShow[]) => {
    return group.slice(0, length ?? Infinity);
  };

  const networkInformationGroupFields = sliceGroup(
    getNetworkInformationGroup(product.servicesWrapper.networkInformation).map(
      getGroup,
    ),
  );

  const callInformationGroupFields = sliceGroup(
    getCallGroup(product.servicesWrapper.callInfo).map(getGroup),
  );

  const televisionInformationGroupFields = sliceGroup(
    getTelevisionGroup(product.servicesWrapper).map(getGroup),
  );

  const ListItemInner = (props: DivProps) => {
    return <Div flexGrow={1} flexBasis={0} {...props} />;
  };

  const listWithHeading = (heading: string, fields: any[]) => {
    return (
      <Div padding={3} flexBasis={'50%'}>
        <P variant="baseBodyImportant">{heading}</P>
        <List variant={'secondary'}>
          {fields.map(({ icon, label, value }: Field, key: number) => {
            let rightFieldContent = value;

            if (icon) {
              rightFieldContent = <Icon height={16} name={icon} width={16} />;
            }

            return (
              <ListItem key={`list-item-${label}-${value}-${key}`}>
                <ListItemInner fontWeight={[1, 0]} mb={[1, 0]}>
                  {label}
                </ListItemInner>
                <ListItemInner my="auto">{rightFieldContent}</ListItemInner>
              </ListItem>
            );
          })}
        </List>
      </Div>
    );
  };

  return (
    <Div display="flex" justifyContent={'flex-start'} flexDirection="column">
      <Div display="flex" width="100%" flexDirection={['column', null, 'row']}>
        <Div pr={[0, null, 1]} width={['100%', null, '50%']}>
          {filtersData?.includes('internet') &&
            listWithHeading('Internet', networkInformationGroupFields)}
          {filtersData?.includes('call') &&
            listWithHeading('Bellen', callInformationGroupFields)}
        </Div>
        <Div width={['100%', null, '50%']}>
          {filtersData?.includes('television') &&
            listWithHeading('Televisie', televisionInformationGroupFields)}
        </Div>
      </Div>
      <Div paddingLeft={2} marginTop={-3}>
        {onButtonInfoClick && (
          <MoreInfoButton
            text="Meer pakket informatie"
            onClick={onButtonInfoClick}
          />
        )}
      </Div>
    </Div>
  );
};
